import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import api from './services/api';
import { BASE_URL } from './services/api';

// Sayfalar
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CurrentAccountsPage from './pages/CurrentAccountsPage';
import CurrentAccountFormPage from './pages/CurrentAccountFormPage';
import CurrentAccountDetailPage from './pages/CurrentAccountDetailPage'; // Yeni eklenen detay sayfası
import ProductsPage from './pages/ProductsPage';
import ProductFormPage from './pages/ProductFormPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CategoriesPage from './pages/CategoriesPage';
import OffersPage from './pages/OffersPage';
import OfferFormPage from './pages/OfferFormPage';
import SalesPage from './pages/SalesPage';
import SaleFormPage from './pages/SaleFormPage';
import TransactionsPage from './pages/TransactionsPage';
import TransactionFormPage from './pages/TransactionFormPage';
import PaymentsPage from './pages/PaymentsPage';
import PaymentFormPage from './pages/PaymentFormPage';
import CashPage from './pages/CashPage';
import CashFormPage from './pages/CashFormPage';
import BankAccountsPage from './pages/BankAccountsPage';
import BankAccountFormPage from './pages/BankAccountFormPage';
import BankTransactionsPage from './pages/BankTransactionsPage';
import BankTransactionFormPage from './pages/BankTransactionFormPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import DealerStockPage from './pages/DealerStockPage';
import DealerDashboardPage from './pages/DealerDashboardPage';
import DealerTransactionsPage from './pages/DealerTransactionsPage';
import LogsPage from './pages/LogsPage';

// Layout Bileşeni: Sidebar ve Navbar'ı içerir
const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
      else if (mobile && !isMobile) setIsSidebarOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="d-flex">
      <Sidebar isOpen={isSidebarOpen} toggle={toggleSidebar} isMobile={isMobile} />
      
      {isMobile && isSidebarOpen && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark opacity-50" 
          style={{ zIndex: 999 }}
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      <div className="flex-grow-1" style={{ marginLeft: !isMobile && isSidebarOpen ? '260px' : '0', transition: 'margin-left 0.3s ease-in-out', width: '100%' }}>
        <Navbar toggleSidebar={toggleSidebar} />
        <div className="p-4">
          {children}
        </div>
      </div>
    </div>
  );
};

function App() {
  // Site Başlığını ve Favicon'u Yükle
  useEffect(() => {
    // Varsayılan başlığı hemen ayarla (API yanıt verene kadar görünmesi için)
    document.title = "Saka Pelet - Yönetim Paneli";

    const fetchSettings = async () => {
      try {
        const response = await api.get('/settings');
        if (response.data.site_title) {
          document.title = response.data.site_title;
        }
        
        // Favicon güncelleme
        const link = document.querySelector("link[rel~='icon']");
        const faviconUrl = `${BASE_URL}/uploads/favicon.ico?v=${new Date().getTime()}`;
        
        if (link) {
          link.href = faviconUrl;
        } else {
          const newLink = document.createElement('link');
          newLink.rel = 'icon';
          newLink.href = faviconUrl;
          document.head.appendChild(newLink);
        }
      } catch (error) {
        console.error('Site ayarları yüklenemedi:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <AuthProvider>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        
        {/* Korumalı Rotalar */}
        <Route path="/" element={<PrivateRoute><Layout><DashboardPage /></Layout></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><Layout><DashboardPage /></Layout></PrivateRoute>} />
        
        {/* Cari Hesaplar */}
        <Route path="/current-accounts" element={<PrivateRoute><Layout><CurrentAccountsPage /></Layout></PrivateRoute>} />
        <Route path="/current-accounts/new" element={<PrivateRoute><Layout><CurrentAccountFormPage /></Layout></PrivateRoute>} />
        <Route path="/current-accounts/edit/:id" element={<PrivateRoute><Layout><CurrentAccountFormPage /></Layout></PrivateRoute>} />
        {/* Detay sayfası rotası */}
        <Route path="/current-accounts/detail/:id" element={<PrivateRoute><Layout><CurrentAccountDetailPage /></Layout></PrivateRoute>} />

        {/* Ürünler & Stok */}
        <Route path="/products" element={<PrivateRoute><Layout><ProductsPage /></Layout></PrivateRoute>} />
        <Route path="/products/new" element={<PrivateRoute><Layout><ProductFormPage /></Layout></PrivateRoute>} />
        <Route path="/products/edit/:id" element={<PrivateRoute><Layout><ProductFormPage /></Layout></PrivateRoute>} />
        <Route path="/products/detail/:id" element={<PrivateRoute><Layout><ProductDetailPage /></Layout></PrivateRoute>} />
        <Route path="/categories" element={<PrivateRoute><Layout><CategoriesPage /></Layout></PrivateRoute>} />

        {/* Teklifler */}
        <Route path="/offers" element={<PrivateRoute><Layout><OffersPage /></Layout></PrivateRoute>} />
        <Route path="/offers/new" element={<PrivateRoute><Layout><OfferFormPage /></Layout></PrivateRoute>} />
        <Route path="/offers/edit/:id" element={<PrivateRoute><Layout><OfferFormPage /></Layout></PrivateRoute>} />

        {/* Satışlar */}
        <Route path="/sales" element={<PrivateRoute><Layout><SalesPage /></Layout></PrivateRoute>} />
        <Route path="/sales/new" element={<PrivateRoute><Layout><SaleFormPage /></Layout></PrivateRoute>} />
        <Route path="/sales/edit/:id" element={<PrivateRoute><Layout><SaleFormPage /></Layout></PrivateRoute>} />

        {/* Borç/Alacak */}
        <Route path="/transactions" element={<PrivateRoute><Layout><TransactionsPage /></Layout></PrivateRoute>} />
        <Route path="/transactions/new" element={<PrivateRoute><Layout><TransactionFormPage /></Layout></PrivateRoute>} />
        <Route path="/transactions/edit/:id" element={<PrivateRoute><Layout><TransactionFormPage /></Layout></PrivateRoute>} />

        {/* Tahsilat/Ödeme */}
        <Route path="/payments" element={<PrivateRoute><Layout><PaymentsPage /></Layout></PrivateRoute>} />
        <Route path="/payments/new" element={<PrivateRoute><Layout><PaymentFormPage /></Layout></PrivateRoute>} />
        <Route path="/payments/edit/:id" element={<PrivateRoute><Layout><PaymentFormPage /></Layout></PrivateRoute>} />

        {/* Kasa */}
        <Route path="/cash" element={<PrivateRoute><Layout><CashPage /></Layout></PrivateRoute>} />
        <Route path="/cash/new" element={<PrivateRoute><Layout><CashFormPage /></Layout></PrivateRoute>} />

        {/* Banka */}
        <Route path="/banks" element={<PrivateRoute><Layout><BankAccountsPage /></Layout></PrivateRoute>} />
        <Route path="/banks/new" element={<PrivateRoute><Layout><BankAccountFormPage /></Layout></PrivateRoute>} />
        <Route path="/banks/detail/:id" element={<PrivateRoute><Layout><BankTransactionsPage /></Layout></PrivateRoute>} />
        <Route path="/banks/detail/:accountId/new-transaction" element={<PrivateRoute><Layout><BankTransactionFormPage /></Layout></PrivateRoute>} />

        {/* Raporlar & Ayarlar */}
        <Route path="/reports" element={<PrivateRoute><Layout><ReportsPage /></Layout></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Layout><SettingsPage /></Layout></PrivateRoute>} />
        
        {/* Loglar */}
        <Route path="/logs" element={<PrivateRoute><Layout><LogsPage /></Layout></PrivateRoute>} />

        {/* Bayi Sistemi */}
        <Route path="/dealer-stock" element={<PrivateRoute><Layout><DealerStockPage /></Layout></PrivateRoute>} />
        <Route path="/dealer-dashboard" element={<PrivateRoute><Layout><DealerDashboardPage /></Layout></PrivateRoute>} />
        <Route path="/dealer-transactions" element={<PrivateRoute><Layout><DealerTransactionsPage /></Layout></PrivateRoute>} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
